import React from "react";

import Header from "./Header"
import Footer from "./Footer"
import ScrollArrow from "./components/ScrollArrow"

function App() {
  return (
    <div>
      <Header />
      <ScrollArrow />
      <Footer />
    </div>
  );
};

export default App;
